module.exports = __webpack_public_path__ + "img/no-apartments.614706f4.png";